export const useClaimStore = defineStore(
	"claimStore",
	() => {
		const onClaimStep = ref(1)
		const eventSelected = ref()

		const ticketSelected = ref(null)
		const lodgingSelected = ref()

		const setOnStep = (value: number) => (onClaimStep.value = value)
		const setEventSelected = (value: any) => (eventSelected.value = value)

		const setTicketSelected = (value: any) => (ticketSelected.value = value)
		const setLodgingSelected = (value: any) => (lodgingSelected.value = value)

		const $reset = () => {
			onClaimStep.value = 1
			eventSelected.value = ""
			ticketSelected.value = null
			lodgingSelected.value = undefined
		}

		return {
			onClaimStep,
			setOnStep,
			eventSelected,
			setEventSelected,
			ticketSelected,
			setTicketSelected,
			lodgingSelected,
			setLodgingSelected,
			$reset,
		}
	},
	{
		persist: {
			key: "up_claimStore", // Make sure this key is unique
			storage: localStorage, // or cookies if you're using cookie storage
		},
	},
)
